import { cva } from "class-variance-authority"
import Actions from "./DialogActions.svelte"
import Close from "./DialogClose.svelte"
import Content from "./DialogContent.svelte"
import Description from "./DialogDescription.svelte"
import Header from "./DialogHeader.svelte"
import Overlay from "./DialogOverlay.svelte"
import Portal from "./DialogPortal.svelte"
import Root from "./DialogRoot.svelte"
import Subtitle from "./DialogSubtitle.svelte"
import Title from "./DialogTitle.svelte"
import Trigger from "./DialogTrigger.svelte"

export type { DialogRootProps } from "./DialogRoot.svelte"

export const Dialog = {
  Content,
  Portal,
  Root,
  Trigger,
  Header,
  Subtitle,
  Description,
  Close,
  Title,
  Overlay,
  Actions,
}

export const actionsVariants = cva("mt-2 flex w-full gap-2", {
  variants: {
    variant: {
      horizontal: "max-sm:flex-col-reverse max-sm:*:w-full",
      vertical: "flex-col items-center",
    },
  },
  defaultVariants: {
    variant: "horizontal",
  },
})
